import { Camera, HardDrive, Monitor, Server, type LucideIcon } from 'lucide-react';
import type { ComponentType } from 'react';
import type { CreateDeviceRequest } from '../../api/devices';
import type { Device } from '../../types';
import { CameraForm } from './CameraForm';
import { RecorderForm } from './RecorderForm';
import { ComputerForm } from './ComputerForm';
import { ServerForm } from './ServerForm';

export type DeviceTypeKey = 'camera' | 'recorder' | 'computer' | 'server';

export interface DeviceTypeMeta {
  key: DeviceTypeKey;
  /** Backend CreateDeviceRequest.deviceType value. */
  backendType: string;
  title: string;
  shortTitle: string;
  description: string;
  icon: LucideIcon;
  defaultPort: number;
  form: ComponentType<DeviceFormProps>;
}

export interface DeviceFormProps {
  recorders: Device[];
  onSubmit: (request: CreateDeviceRequest) => Promise<void>;
  onCancel: () => void;
}

/** Forms for the four device types supported by the API. */
export const deviceTypes: Record<DeviceTypeKey, DeviceTypeMeta> = {
  camera: {
    key: 'camera',
    backendType: 'Camera',
    title: 'Камера',
    shortTitle: 'Камера',
    description: 'IP-камера с RTSP/ONVIF и живым просмотром',
    icon: Camera,
    defaultPort: 554,
    form: CameraForm,
  },
  recorder: {
    key: 'recorder',
    backendType: 'Dvr',
    title: 'Видеорегистратор',
    shortTitle: 'Регистратор',
    description: 'DVR / NVR / XVR с каналами для камер',
    icon: HardDrive,
    defaultPort: 80,
    form: RecorderForm,
  },
  computer: {
    key: 'computer',
    backendType: 'Computer',
    title: 'Компьютер',
    shortTitle: 'Компьютер',
    description: 'Рабочая станция с сетевой проверкой доступности',
    icon: Monitor,
    defaultPort: 135,
    form: ComputerForm,
  },
  server: {
    key: 'server',
    backendType: 'Server',
    title: 'Сервер',
    shortTitle: 'Сервер',
    description: 'Физический или виртуальный сервер',
    icon: Server,
    defaultPort: 443,
    form: ServerForm,
  },
};

export const deviceTypeList: DeviceTypeMeta[] = Object.values(deviceTypes);

